import React, { ReactElement } from 'react'
import { getUploadCount } from '../../services/utils'
import { deleteIcon } from '../../assets/images/images'

function UploadPreview({
  file,
  removeFile,
  showDelete,
  className = '',
}: {
  file: File
  removeFile: () => void
  showDelete: boolean
  className?: string
}): ReactElement {
  return (
    <div className={`dFlex wFull alignItemsCenter uploadPreview ${className}`}>
      <div className="fileName wFull">{decodeURIComponent(file.name)}</div>
      {showDelete && getUploadCount() < 3 && (
        <span onClick={removeFile} className="pointer ml1">
          <img src={deleteIcon} alt="delete" />
        </span>
      )}
    </div>
  )
}

export default UploadPreview
